import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GenericDataResponse, PropertySinceResponse } from '@vi-iot/client';
import { AnalyticsApiPicker } from '@vi-iot/client/apis/analytics/analytics.api-picker';
import { RemoteServiceApiPicker } from '../../../projects/client/apis/remote-service/remote-service.api-picker';
import { AnalyticsActions } from './analytics.actions';

@Injectable()
export class AnalyticsEffects {
  constructor(
    private actions$: Actions,
    private remoteServiceApiPicker: RemoteServiceApiPicker,
    private analyticsApiPicker: AnalyticsApiPicker
  ) {}

  getHemsFeaturesPresentSince: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnalyticsActions.hemsFeaturesPresentSince.attempt),
      switchMap((action) =>
        this.remoteServiceApiPicker
          .instance()
          .getDeviceAvailableHemsProperties(action.hemsFeaturesPresentSincePayload)
          .pipe(
            map((hemsFeaturesPresentSinceResponse) =>
              AnalyticsActions.hemsFeaturesPresentSince.success({
                hemsFeaturesPresentSince: hemsFeaturesPresentSinceResponse.data,
              })
            ),
            catchError((error) => of(AnalyticsActions.hemsFeaturesPresentSince.error(error)))
          )
      )
    );
  });

  loadAvailableChronosFeatures: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnalyticsActions.loadAvailableChronosFeatures.attempt),
      switchMap((action) => {
        return this.analyticsApiPicker
          .instance()
          .getDeviceAvailableProperties({
            gateway_id: action.gateway_id,
          })
          .pipe(
            map((dataFromApi: GenericDataResponse<PropertySinceResponse>) => {
              return AnalyticsActions.loadAvailableChronosFeatures.success({
                deviceWithAvailableFeatures: dataFromApi.data,
              });
            }),
            catchError((error) =>
              of(AnalyticsActions.loadAvailableChronosFeatures.error({ error }))
            )
          );
      })
    );
  });
}
